const initialState = {
	data: [],
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
	total: 0,
}

const Lists = (state = initialState, action) => {
	switch (action.type) {
		case 'CG_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
			}
		case 'CG_ADD_DATA':
			const aData = [...state.data, action.data]
			return Object.assign({ ...state, data: aData, total: state.total + 1 })
		case 'CG_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const uData = state.data
			uData[index] = action.data
			return Object.assign({ ...state, data: [...uData] })
		case 'CG_DEL_DATA':
			const dData = state.data.filter((e) => e.id !== action.index)
			return { ...state, data: dData }
		case 'CG_GET_CURRENT':
			return { ...state, selected: action.selected }
		case 'CG_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default Lists
